module.exports = __webpack_public_path__ + "img/completeed.869d5240.svg";